import './App.css';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import SummaryApi from './common';
import Context from './context';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './store/userSlice';
import { setCartCount } from "./store/cartSlice";
import ScrollToTop from './components/ScrollToTop';
import WhatsappButton from './components/WhatsappButton';
// import Home from './pages/Home';
// import Preloader from './components/Preloader';

function App() {
const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [cartProductCount, setCartProductCount] = useState(0);

  // 🔥 Fetch Logged-in User
  const fetchUserDetails = async () => {
    try {
      const dataResponse = await fetch(
        SummaryApi.current_user.url,
        {
          method: SummaryApi.current_user.method,
          credentials: 'include'
        }
      );

      const dataApi = await dataResponse.json();

      if (dataApi.success) {
        dispatch(setUserDetails(dataApi.data));
      } else {
        dispatch(setUserDetails(null));
      }

    } catch (error) {
      dispatch(setUserDetails(null));
    }
  };

  // 🔥 Fetch Cart Count (Context version)
  const fetchUserAddToCart = async () => {
    try {
      const dataResponse = await fetch(
        SummaryApi.addToCartProductCount.url,
        {
          method: SummaryApi.addToCartProductCount.method,
          credentials: 'include'
        }
      );

      const dataApi = await dataResponse.json();

      if (dataApi.success) {
        setCartProductCount(dataApi.data.count);
        dispatch(setCartCount(dataApi.data.count));
      }

    } catch (error) {
      dispatch(setCartCount(0));
    }
  };

  // 🔥 IMPORTANT — Restore user + cart on refresh
  useEffect(() => {
    fetchUserDetails();
    fetchUserAddToCart();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    },3000)
  },[]);

  return (
    <>
      <Context.Provider
        value={{
          fetchUserDetails,
          cartProductCount,
          fetchUserAddToCart
        }}
      >
        <ToastContainer position='top-right' autoClose={2000} />

        <Header />

        <main className='min-h-[calc(100vh-120px)] pt-16 md:pt-20 pb-20'>
          <Outlet />
        </main>

        <Footer />
        <WhatsappButton/>
       
        <ScrollToTop/>

      </Context.Provider>
    </>
  );
}

export default App;